<template>
  <FullPage title="Cashup">
    <BasicCashupForm v-if="showForm"/>
  </FullPage>
</template>

<script>
import BasicCashupForm from "@/components/point-of-sale/cashup/BasicCashupForm";
import FullPage from "@/components/layout/utils/FullPage";
import { runCashupOfflineStatusCheck } from "@/services/deviceOfflineStatusService";
import Swal from "sweetalert2";

/**
 * End User Shift screen (`/#/cashup`).
 * Owns device offline-status POST snapshot + GET latestAll (not BasicCashupForm).
 * Blocks if this PC has local unsent sales OR any store device has notSynced/failed > 0.
 */
export default {
  name: "CashupView",
  components: { FullPage, BasicCashupForm },
  data() {
    return {
      showForm: false
    };
  },
  async beforeMount() {
    console.log("[CashupView] End User Shift — offline status check");
    const {
      pendingLocalCount,
      serverBacklogCount,
      shouldBlock,
      devicesWithBacklog
    } = await runCashupOfflineStatusCheck().catch((err) => {
      console.warn("[CashupView] offline status check error", err);
      return {
        pendingLocalCount: 0,
        serverBacklogCount: 0,
        shouldBlock: false,
        devicesWithBacklog: []
      };
    });

    if (shouldBlock) {
      const displayCount = Math.max(pendingLocalCount, serverBacklogCount);
      let detailHtml = "";
      if (
        pendingLocalCount > 0 &&
        serverBacklogCount > 0 &&
        pendingLocalCount !== serverBacklogCount
      ) {
        detailHtml =
          `<br><small>Local outbox: ${pendingLocalCount} · Store offline-status: ${serverBacklogCount}</small>`;
      } else if (pendingLocalCount === 0 && serverBacklogCount > 0) {
        const names = (devicesWithBacklog || [])
          .map((d) => d.pcName)
          .filter(Boolean)
          .slice(0, 5);
        const nameBit = names.length
          ? ` Devices with backlog: <strong>${names.join(", ")}</strong>.`
          : "";
        detailHtml =
          `<br><small>Another device still has offline sales (local outbox is clear).` +
          nameBit +
          `</small>`;
      }
      const result = await Swal.fire({
        icon: "warning",
        title: "Cannot Cash Up",
        html:
          `There are <strong>${displayCount}</strong> offline sale(s) that haven't been synced yet.` +
          detailHtml +
          `<br><br>Please sync all pending/failed sales on every till before cashing up.`,
        showCancelButton: true,
        confirmButtonText: "Go to Offline Invoices",
        cancelButtonText: "Cancel"
      });
      if (result.isConfirmed) {
        this.$router.push({ name: "offline-invoices" });
      } else {
        this.$router.push({ name: "float" });
      }
      return;
    }

    this.showForm = true;
  }
};
</script>
